import React, { forwardRef } from "react";
import { AccentSpinner } from "../../controls/AccentSpinner";
import { t } from "../../services/HelperService";
import ChatCtrl from "../../controls/chat/ChatCtrl";

const CustomerChatRightPane = forwardRef(function CustomerChatRightPane(
    {
        selected,
        chatDlgProps,
        isSwitching = false,
        isWhatsApp = true,
        showBackButton = false,
        onBackClick,
        onSubjectUpdated,
        onStatusUpdated,
        onContactLinked,
        onAssigneeUpdated,
        onLinkedJobsUpdated
    },
    chatDlgRef
) {
    return (
        <div className="ccv-right-pane">
            {selected ? (
                <div className="h-100 d-flex flex-column">
                    <div className="flex-grow-1">
                        {chatDlgProps ? (
                            <div style={{ position: "relative", flex: 1, minWidth: 0 }}>
                                <ChatCtrl
                                    ref={chatDlgRef}
                                    {...chatDlgProps}
                                    showBackButton={showBackButton}
                                    onBackClick={onBackClick}
                                    referenceNo={selected?.ID}
                                    subject={selected?.Subject || t("application_strings.views.chat.channelTitle", { contactPoint: selected?.ContactPoint })}
                                    contactPoint={selected?.ContactPoint}
                                    contactPointDisplayName={selected?.ContactPointDisplayName}
                                    contactID={selected?.ContactID ?? null}
                                    from={selected?.From}
                                    fromDisplayName={selected?.FromDisplayName}
                                    openDate={selected?.OpenDate}
                                    archivedDate={selected?.ArchivedAt}
                                    archivedBy={selected?.ArchivedByRepresentativeName}
                                    isReadOnly={selected?.IsArchived || !selected?.CanEdit}
                                    status={selected?.Status}
                                    closeDate={selected?.CloseDate ?? null}
                                    representativeAssigneeName={selected?.RepresentativeAssigneeName}
                                    teamAssigneeName={selected?.TeamAssigneeName}
                                    linkedJobs={selected?.LinkedJobs ?? []}
                                    onSubjectUpdated={onSubjectUpdated}
                                    onStatusUpdated={onStatusUpdated}
                                    onContactLinked={onContactLinked}
                                    onAssigneeUpdated={onAssigneeUpdated}
                                    onLinkedJobsUpdated={onLinkedJobsUpdated}
                                />
                                {isSwitching && (
                                    <div className="ccv-rhs-overlay"><AccentSpinner /></div>
                                )}
                            </div>
                        ) : (
                            isWhatsApp
                                ? <div className="h-100 d-flex align-items-center justify-content-center"><AccentSpinner /></div>
                                : <div className="text-muted p-3">{t("application_strings.views.chat.rightPane.unsupportedChannel")}</div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="text-center text-muted" style={{ marginTop: 50 }}>
                    {t("application_strings.views.chat.rightPane.selectChat")}
                </div>
            )}
        </div>
    );
});

export default CustomerChatRightPane;
export { CustomerChatRightPane };
